import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { LabelWithIconComponent } from './label-with-icon.component';

@NgModule({
  imports: [CommonModule, IconModule],
  declarations: [LabelWithIconComponent],
  exports: [LabelWithIconComponent]
})
export class LabelWithIconModule {}
